<template>
  <div class="container-fluid">
    <div class="row pb-2" v-show="!editMode || (editMode && editFull)">
      <div class="col-7 col-no-padding">
        <form class="form">
          <div class="form-row row">
            <label class="col-12">{{ $t("plans.form.label") }}</label>
            <input
              ref="label"
              type="text"
              class="form-input col-12"
              :class="isLabelMissing && 'invalid'"
              v-model="label"
            />
            <p v-if="isLabelMissing" class="text-danger-600 m-0">
              {{ $t("validation.required_field") }}
            </p>
          </div>
          <div class="form-row row">
            <label class="col-12">{{ $t("plans.form.address") }}</label>
            <AddressField
              class="w-full"
              :center="center"
              :zoom="zoom"
              :address="address"
              :fullAddress="address"
              @location="handleLocation"
              @centerMap="handleMapCenter"
            />
          </div>
        </form>
      </div>
      <div class="col-5 col-no-padding">
        <MiniMap
          ref="minimap"
          :id="'minimap-site'"
          :center="center"
          :zoom="zoom"
          @centerMap="handleMapCenter"
        ></MiniMap>
      </div>
    </div>
    <div class="row pb-2" v-show="editMode && !editFull">
      <div class="col-12 col-no-padding">
        <form class="form">
          <div class="form-row row">
            <label class="col-12">{{ $t("plans.form.label") }}</label>
            <input
              type="text"
              class="form-input col-12"
              v-model="label"
              :class="isLabelMissing && 'invalid'"
            />
            <p v-if="isLabelMissing" class="text-danger-600 m-0">
              {{ $t("validation.required_field") }}
            </p>
          </div>
        </form>
      </div>
    </div>
    <Toolbar class="not-fixed pb-3 px-3">
      <Btn class="primary" @click.native.stop="handleSave">
        {{ $t("global.save") }}
      </Btn>
      <Btn @click.native.stop="cancel">
        {{ $t("global.cancel") }}
      </Btn>
    </Toolbar>
  </div>
</template>

<script>
import Toolbar from "@/components/ui/Toolbar";
import AddressField from "@/components/ui/fields/AddressField";
import Btn from "@/components/ui/Button";
import MiniMap from "@/components/plans/map/MiniMap";

export default {
  beforeCreate: function () {},
  beforeDestroy: function () {},
  beforeMount: function () {},
  beforeUpdate: function () {},
  components: {
    Toolbar,
    Btn,
    MiniMap,
    AddressField,
  },
  computed: {},
  created: function () {},
  data() {
    return {
      label: "",
      obj: null,
      center: null,
      zoom: null,
      address: "",
      editMode: false,
      editFull: false,
      isLabelMissing: false,
    };
  },
  destroyed: function () {},
  methods: {
    resetForm: function () {
      this.label = "";
      this.address = "";
      this.isLabelMissing = false;
    },
    cancel: function () {
      this.resetForm();
      this.$emit("close", "add", "site");
    },
    handleLocation: function (location) {
      this.address = location.address;
      this.center = location.center;
      this.zoom = 16;
    },
    handleMapCenter: function (location) {
      this.center = location.center;
      this.zoom = location.zoom;
    },
    handleSave: function () {
      if (this.label.length == 0) {
        this.isLabelMissing = true;
        return;
      } else {
        this.isLabelMissing = false;
        this.valid();
      }
    },
    valid: function () {
      if (this.editMode) {
        this.obj.name = this.label;
        if (this.editFull) {
          this.obj.where = {
            point: {
              lng: this.$refs.minimap.map._map.getCenter().lng,
              lat: this.$refs.minimap.map._map.getCenter().lat,
            },
            addressLabel: this.address,
          };
          this.obj.zoom = this.$refs.minimap.map._map.getZoom();
        }
        this.$emit("editSite", this.obj);
      } else {
        var obj = {
          type: 2,
          name: this.label,
          where: {
            point: {
              lng: this.$refs.minimap.map._map.getCenter().lng,
              lat: this.$refs.minimap.map._map.getCenter().lat,
            },
            addressLabel: this.address,
          },
          zoom: this.$refs.minimap.map._map.getZoom(),
        };

        this.$emit("addSite", obj);
      }

      //this.resetForm();
    },
    edit: function (edit, obj) {
      if (edit == null) {
        edit = false;
      }
      this.editFull = false;
      this.editMode = edit;
      if (obj != null) {
        this.obj = obj;
        this.label = obj.name;
        if (obj.where) {
          if (obj.where.point) {
            this.center = {
              lng: obj.where.point.lng,
              lat: obj.where.point.lat,
            };
          }
          if (obj.where.addressLabel) {
            this.address = obj.where.addressLabel;
          }
        }
        if (obj.zoom) {
          this.zoom = obj.zoom;
        }
        if (
          !obj.hasAPs &&
          (!obj.children || (obj.children && obj.children.length == 0))
        ) {
          this.editFull = true;
        }
      }
      if (!edit) {
        this.$refs.label.focus();
      }
    },
  },
  mounted: function () {},
  name: "",
  props: [],
  updated: function () {},
  watch: {
    label: function (newVal) {
      if (newVal.length > 0) {
        // Fait pour retirer l'erreur, pas l'ajouter (géré au save)
        this.isLabelMissing = newVal.length == 0;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
